var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BWW-Ecosystem-2020---[Trivia]-Herd-Gameplay",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trivia-[Herd]---Create-(Step-3)-(Invite)",
    transform: "translate(-284.000000, -594.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(0.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fields",
    transform: "translate(40.000000, 315.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input",
    transform: "translate(0.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Join-Button",
    transform: "translate(230.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7606383,2.18278728e-12 C9.80845267,0.000149594366 9.85469069,0.0153018803 9.89303414,0.0428530757 L9.92021277,0.0658005836 L9.92781155,0.0658005836 L9.93414387,0.0733926351 C9.96740099,0.107601534 9.98913788,0.150964186 9.99686776,0.197460236 L10,0.232825717 L10,1.9995 L11.7606383,2 C11.8084527,2.00014959 11.8546907,2.01530188 11.8930341,2.04285308 L11.9202128,2.06580058 L11.9278116,2.06580058 L11.9341439,2.07339264 C11.967401,2.10760153 11.9891379,2.15096419 11.9968678,2.19746024 L12,2.23282572 L12,11.769705 C11.999805,11.8172718 11.9849648,11.8633206 11.9579324,11.901796 L11.9354103,11.929138 L11.9278116,11.9367301 L11.9001111,11.9590479 C11.8709131,11.9790993 11.8375077,11.9922397 11.8024645,11.9974587 L11.7669706,12 L2.2393617,12 C2.19154733,11.9998504 2.14530931,11.9846981 2.10696586,11.9571469 L2.07978723,11.9341994 L2.07218845,11.9341994 L2.06585613,11.9266074 C2.03259901,11.8923985 2.01086212,11.8490358 2.00313224,11.8025398 L2,11.7671743 L1.9995,10 L0.239361702,10 C0.191547333,9.99985041 0.145309306,9.98469812 0.106965861,9.95714692 L0.079787234,9.93419942 L0.0721884498,9.93419942 L0.0658561297,9.92660736 C0.0325990146,9.89239847 0.0108621195,9.84903581 0.00313223901,9.80253976 L7.27595761e-13,9.76717428 L7.27595761e-13,0.230295033 C0.000194959144,0.182728161 0.0150351783,0.136679448 0.0420676207,0.0982039687 L0.0645896657,0.0708619513 L0.0721884498,0.0632698998 L0.0998888956,0.0409521373 C0.129086949,0.0209006719 0.162492322,0.00776033374 0.197535473,0.00254125148 L0.233029382,2.18278728e-12 L9.7606383,2.18278728e-12 Z M10.4878419,3.507 L10,3.507 L10,9.76970497 C9.99980504,9.81727184 9.98496482,9.86332055 9.95793238,9.90179603 L9.93541033,9.92913805 L9.92781155,9.9367301 L9.9001111,9.95904786 C9.87091305,9.97909933 9.83750768,9.99223967 9.80246453,9.99745875 L9.76697062,10 L3.512,10 L3.51215805,10.492975 L7.86602328,10.4923817 L7.89339355,10.4856507 L7.93211753,10.4815897 L10.4878419,10.4815897 L10.4878419,3.507 Z",
    id: "Shape"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/IconCopy.7011059d.svg";
export { ForwardRef as ReactComponent };